export default function (context, val) {
    val.request.sum = val.value;
}